import { useSelector } from "react-redux";
import sidebarData from "../components/sidebar/sidebarData";
import { getModuleAuthority } from "../auth/authHelper";
import { MODULES } from "../const";

const findFirstAuthorizedModule = (permissions) => {
  const navItems = Object.keys(sidebarData);
  for (const item of navItems) {
    const auth = permissions[MODULES[item]];
    if (getModuleAuthority(auth).view) {
      return item;
    }
  }
  return null;
};

const useFirstModule = (currentModule) => {
  const permissions = useSelector((state) => state.user.permissions);
  if (!permissions) {
    return null;
  }
  if (!currentModule) {
    return findFirstAuthorizedModule(permissions);
  } else {
    const auth = permissions[MODULES[currentModule]];
    if (getModuleAuthority(auth).view) {
      return currentModule;
    }
    return findFirstAuthorizedModule(permissions);
  }
};

export default useFirstModule;
